import React, { lazy } from "react";
import DashboardLayout from "./Layout/DashboardLayout";
import { Navigate } from "react-router-dom";

import User from "pages/AccessManagement/User";
import RoleAccess from "pages/AccessManagement/RoleAccess";
import RoleList from "pages/AccessManagement/Roles";
import UserManageObject from "pages/AccessManagement/Objects";
import Error_404 from "pages/Errors/Error_404";
import Error_401 from "pages/Errors/Error_401";
import Dashboard from "pages/Dashboard";
import { Programs as ProgramSetup, Task, WeeklyTimeSheet, TeamWeeklyTimeSheet, TeamMonthlyTimeSheet } from "pages/TimeSheetManage";
import { View as ProgramSetupView } from "pages/TimeSheetManage/Programs/component";
import { Directions, Programs, Queues, Languages, Geographies, Source, Import, ACDIntegration, Logs } from "pages/ACD/Admin";
import Brands from "pages/ACD/Admin/Brands";
import Categories from "pages/TimeSheetManage/Categories";
import MonthlyBilling from "pages/TimeSheetManage/Reports/MonthlyBilling";
import { TimeByProgram, TimeByUser, AccountManagerMonthlyReport } from "pages/TimeSheetManage/Reports";
import BussinesModel from "pages/ACD/Admin/BussinesModel";
import TotalDashboard from "pages/ACD/TotalDashboard";
import MonthlyACD from "pages/ACD/MonthlyACD";
import DailyACD from "pages/ACD/DailyACD";
import LogsDetails from "pages/ACD/Admin/Logs/component/View";
import { UpdateInvoiceConfiguration } from "pages/InvoiceConfiguration/component";
import Invoices from "pages/Invoices";
import { InvoicesUpdate } from "pages/Invoices/component";
import SetupConfiguration from "pages/SetupConfiguration";

const Postage = lazy(() => import("pages/PostageManagement/Postage"));
const PostageAccounts = lazy(() => import("pages/PostageManagement/PostageAccounts"));

const routes = [
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        index: true, // Default child route
        element: <Navigate to="/dashboard" />,
      }, 
      {
        path: "user",
        element: <User/>,
      },

      {
        path: "role_access",
        element: <RoleAccess/>,
      },

      {
        path: "roles",
        element: <RoleList/>,
      },

      {
        path: "object",
        element: <UserManageObject/>,
      },

      {
        path: "dashboard",
        element: <Dashboard />,
      },

      {
        path: "postage",
        element: <Postage />,
      },

      {
        path: "postage-accounts",
        element: <PostageAccounts />,
      },

      {
        path: "programs-setup",
        element: <ProgramSetup />,
      },

      {
        path: "programs-setup/add",
        element: <ProgramSetupView />,
      },

      {
        path: "task",
        element: <Task />,
      },

      {
        path: "categories",
        element: <Categories />,
      },

      {
        path: "weeklytimesheet",
        element: <WeeklyTimeSheet />,
      },
      {
        path: "teamWeeklytimesheet",
        element: <TeamWeeklyTimeSheet />,
      },
      {
        path: "teamMonthlytimesheet",
        element: <TeamMonthlyTimeSheet />,
      },

      {
        path: "monthlybilling",
        element: <MonthlyBilling />,
      },

      {
        path: "timebyprogram",
        element: <TimeByProgram />,
      },
      {
        path: "accountmanagermonthlyreport",
        element: <AccountManagerMonthlyReport />,
      },

      {
        path: "program",
        element: <Programs />,
      },

      {
        path: "queues",
        element: <Queues />,
      },

      {
        path: "brands",
        element: <Brands />,
      },

      {
        path: "directions",
        element: <Directions/>,
      },

      {
        path: "geographies",
        element: <Geographies/>,
      },

      {
        path: "languages",
        element: <Languages/>,
      },

      {
        path: "source",
        element: <Source/>,
      },

      {
        path: "bussinesmodel",
        element: <BussinesModel/>,
      },

      {
        path: "totalDashboard",
        element: <TotalDashboard/>,
      },

      {
        path: "monthlyACD",
        element: <MonthlyACD/>,
      },

      {
        path: "dailyACD",
        element: <DailyACD/>,
      },

      {
        path: "integration",
        element: <ACDIntegration/>,
      },

      {
        path: "acd-job-logs",
        element: <Logs/>,
      },

      {
        path: "acd-job-logs/view/:id",
        element: <LogsDetails/>,
      },

      {
        path: "import",
        element: <Import/>,
      },
      // invoiceConfiguration
      {
        path: "invoiceConfiguration",
        element: <UpdateInvoiceConfiguration/>,
      },

      {
        path: "invoices",
        element: <Invoices/>,
      },

      {
        path: "invoices/update",
        element: <InvoicesUpdate/>,
      },

      {
        path: "setup-configuration",
        element: <SetupConfiguration />,
      },

      {
        path: "errors",
        children: [
          {
            path: "error-404",
            element: <Error_404 />,
          },
          {
            path: "error-401",
            element: <Error_401 />,
          },
        ],
      },
    ],
  },
];

export default routes;
 